import { render, staticRenderFns } from "./LeftSideNav.vue?vue&type=template&id=3afe1e8a&scoped=true"
import script from "./LeftSideNav.vue?vue&type=script&lang=js"
export * from "./LeftSideNav.vue?vue&type=script&lang=js"
import style0 from "./LeftSideNav.vue?vue&type=style&index=0&id=3afe1e8a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afe1e8a",
  null
  
)

export default component.exports